import { areaQueryKeys as e } from "./useAreaQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { areaApi as n } from "@maat/api-main";
//#region src/areas/useAreaQuery.ts
var r = (r) => t({
	queryKey: e.list(r),
	queryFn: () => n.getAreas(r)
});
//#endregion
export { r as useAreaQuery };
